import React from "react";
import DuoDrawerLayout from "../layout/DuoDrawerLayout";
import { Link } from "react-router-dom";
import SEO from "../components/seo";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faVideo, faMicrophone } from "@fortawesome/free-solid-svg-icons";
import IntlContext from "../context/IntlContext";

function SecurityPage() {

	const SecurityBox = ({ icon, text }) => {
		return (
			<div className="box rounded-s shadow-s">
				<FontAwesomeIcon icon={icon} style={{ fontSize: `2.3em` }}/>
				<strong style={{ fontSize: `1.4em`, lineHeight: `1.5em`, marginLeft: `20px` }}>{text}</strong>
			</div>
		)
	}

	const SecurityImg = ({ data }) => {
		return (
			<div className="img img-responsive mt-2 mb-2 text-center">
				<img src={data.src} width={`67%`} alt={data.alt}/>
			</div>
		)
	}

	const img1 = require(`../assets/images/pictogrammes/camera.png`)
	const img2 = require(`../assets/images/pictogrammes/sos.png`)

	return (
		<DuoDrawerLayout lightTheme={false}>
			<IntlContext.Consumer>
				{({ translations, locale }) => (
					<div className="content-no-image">
						<SEO title={translations.START.SLIDE2.TITLE} lang={locale} />
						<h1 className="mb-5">{translations.START.SLIDE2.TITLE.toUpperCase()}</h1>

						<div className="content mb-5 pb-3">
							<div className="list-group list-boxes">
								<SecurityImg data={ {"src": img1, "alt": "camera"} }/>
								<SecurityImg data={ {"src": img2, "alt": "sos"} }/>
							</div>
						</div>

						<Link to='/visit/1'
							  className="btn btn-l bg-highlight btn-center-auto btn-icon shadow-l font-900 text-uppercase">
							{translations.START.SLIDE2.GOTOVISIT}
						</Link>
					</div>
				)}
			</IntlContext.Consumer>
		</DuoDrawerLayout>
	)

}

export default SecurityPage